import { Link } from "react-router-dom";

const DeleteAccountPage = () => {
  return (
    <div className="doc-page">
      <nav className="doc-nav" data-testid="delete-account-nav">
        <Link className="nav-logo" to="/" data-testid="nav-logo">
          <img src="/ruler-icon.png" alt="" className="nav-logo-icon-img-sm" />
          <span className="nav-logo-text-sm">Kids Size Finder</span>
        </Link>
        <Link className="nav-back" to="/" data-testid="nav-back-link">← Back to home</Link>
      </nav>

      <main className="doc-main" data-testid="delete-account-content">
        <div className="doc-header">
          <div className="doc-title">Delete Your Account</div>
          <div className="doc-meta">Last updated: April 2026</div>
        </div>

        <p>You can delete your Kids Size Finder account and all associated data at any time. Deleting your account permanently removes your profile, all saved child profiles and measurements, and your preferences. This action cannot be undone.</p>

        <h2>Delete from within the app</h2>
        <p>The fastest way to delete your account is directly from the Kids Size Finder app:</p>

        <div className="step-box">
          <div className="step-row"><span className="step-number">1</span><span className="step-title">Open Kids Size Finder</span></div>
          <div className="step-desc">Launch the app on your device.</div>
        </div>

        <div className="step-box">
          <div className="step-row"><span className="step-number">2</span><span className="step-title">Go to Settings</span></div>
          <div className="step-desc">Tap the settings icon in the top right corner of the home screen.</div>
        </div>

        <div className="step-box">
          <div className="step-row"><span className="step-number">3</span><span className="step-title">Tap "Delete Account"</span></div>
          <div className="step-desc">Scroll to the bottom of Settings and tap "Delete Account". A confirmation dialog will appear — confirm to permanently delete your account and all data.</div>
        </div>

        <h2>Delete by email</h2>
        <p>If you no longer have access to the app or are unable to delete your account from within the app, email us and we will process the deletion manually:</p>

        <div className="highlight-box">
          <p>📧 <a href="mailto:privacy@kidssizefinder.com" className="email-link">privacy@kidssizefinder.com</a><br />
          Please include the email address associated with your account. We will confirm deletion within 7 days.</p>
        </div>

        <h2>What gets deleted</h2>
        <p>When your account is deleted, the following data is permanently removed:</p>
        <ul>
          <li>Your account and login information</li>
          <li>All saved child profiles and measurement history</li>
          <li>Your preferred brands and settings</li>
        </ul>

        <h2>Timeline</h2>
        <p>Your data is permanently deleted from our active systems within <strong>30 days</strong> of your deletion request. Backup copies are purged within <strong>90 days</strong>. After deletion is complete no data about you or your children is retained.</p>

        <h2>Questions</h2>
        <p>If you have any questions about account deletion or your data, contact us at <a href="mailto:privacy@kidssizefinder.com" className="email-link">privacy@kidssizefinder.com</a>.</p>

        <p style={{ marginTop: "32px" }}>Outgrow Solutions Oy &nbsp;·&nbsp; Hedelmäkatu 1 A, 33270 Tampere, Finland</p>
      </main>

      <footer className="doc-footer" data-testid="delete-account-footer">
        <div className="footer-links">
          <Link to="/">Home</Link>
          <Link to="/privacy">Privacy Policy</Link>
          <Link to="/terms">Terms of Service</Link>
          <a href="mailto:support@kidssizefinder.com">Support</a>
        </div>
        <p className="footer-copy">© 2026 Outgrow Solutions Oy. All rights reserved.</p>
      </footer>
    </div>
  );
};

export default DeleteAccountPage;
